/**
 * Bilingual copy for the Portfolios page.
 * `en` holds the exact original English strings; `km` mirrors them in Khmer.
 */
export const en = {
  pageTitle: 'Industries We Serve',
  clientsTitle: 'Our Clients',
  clientLogoAlt: 'Client logo',
  sectors: [
    'Banking & Finance',
    'Retail & E-commerce',
    'Manufacturing',
    'Healthcare',
    'Hospitality',
    'Education',
    'Insurance',
    'Government',
    'Telecommunications',
    'Agriculture',
  ],
  portfolios: [
    {
      title: 'ABC Bank',
      category: 'Banking',
      description:
        "Implemented a comprehensive HRMS and CRM solution for one of Cambodia's leading banks, streamlining operations across 25 branches and improving customer service efficiency by 40%.",
      image: '/images/portfolios/portfolio-banner.jpg',
    },
    {
      title: 'XYZ Retail Group',
      category: 'Retail',
      description:
        'Deployed our integrated inventory and accounting modules, helping this retail chain manage stock across 12 locations while providing real-time financial insights to management.',
      image: '/images/portfolios/portfolio-banner.jpg',
    },
    {
      title: 'Golden Insurance',
      category: 'Insurance',
      description:
        'Provided a tailored insurance management solution that reduced policy processing time by 60% and improved customer satisfaction scores by 35% within the first six months.',
      image: '/images/portfolios/portfolio-banner.jpg',
    },
    {
      title: 'Sunrise Hotels',
      category: 'Hospitality',
      description:
        'Implemented our HRMS system to manage staff across 5 hotel properties, optimizing scheduling and reducing administrative overhead by 30%.',
      image: '/images/portfolios/portfolio-banner.jpg',
    },
    {
      title: 'Cambodia Manufacturing Co.',
      category: 'Manufacturing',
      description:
        'Deployed our complete business suite to integrate production planning, inventory management, and financial operations, resulting in a 25% increase in operational efficiency.',
      image: '/images/portfolios/portfolio-banner.jpg',
    },
    {
      title: 'Green Agriculture',
      category: 'Agriculture',
      description:
        'Implemented a customized inventory and operations management system for this agricultural supplier, helping them track produce from farm to consumer.',
      image: '/images/portfolios/portfolio-banner.jpg',
    },
  ],
  cta: {
    title: 'Ready to become our next success story?',
    body: 'Contact us today to discuss how AKAS solutions can transform your business operations.',
    button: 'Contact Us',
  },
};

export type Copy = typeof en;

export const km: Copy = {
  pageTitle: 'វិស័យដែលយើងបម្រើ',
  clientsTitle: 'អតិថិជនរបស់យើង',
  clientLogoAlt: 'ឡូហ្គោអតិថិជន',
  sectors: [
    'ធនាគារ និងហិរញ្ញវត្ថុ',
    'ការលក់រាយ និងពាណិជ្ជកម្មអនឡាញ',
    'ផលិតកម្ម',
    'សុខាភិបាល',
    'បដិសណ្ឋារកិច្ច',
    'អប់រំ',
    'ធានារ៉ាប់រង',
    'រដ្ឋាភិបាល',
    'ទូរគមនាគមន៍',
    'កសិកម្ម',
  ],
  portfolios: [
    {
      title: 'ABC Bank',
      category: 'ធនាគារ',
      description:
        'ធនាគារឈានមុខគេមួយរបស់កម្ពុជាបានដាក់ឱ្យប្រើប្រព័ន្ធគ្រប់គ្រងធនធានមនុស្ស និងប្រព័ន្ធគ្រប់គ្រងទំនាក់ទំនងអតិថិជនពេញលេញរបស់យើង។ ប្រតិបត្តិការនៅសាខាទាំង 25 ដំណើរការរលូនជាងមុន ហើយប្រសិទ្ធភាពនៃសេវាអតិថិជនកើនឡើង 40%។',
      image: '/images/portfolios/portfolio-banner.jpg',
    },
    {
      title: 'XYZ Retail Group',
      category: 'ការលក់រាយ',
      description:
        'ម៉ូឌុលស្តុក និងគណនេយ្យដែលភ្ជាប់គ្នា ជួយបណ្តាញហាងលក់រាយនេះគ្រប់គ្រងស្តុកនៅទីតាំងទាំង 12។ អ្នកគ្រប់គ្រងក៏មើលព័ត៌មានហិរញ្ញវត្ថុបានភ្លាមៗផងដែរ។',
      image: '/images/portfolios/portfolio-banner.jpg',
    },
    {
      title: 'Golden Insurance',
      category: 'ធានារ៉ាប់រង',
      description:
        'ដំណោះស្រាយគ្រប់គ្រងធានារ៉ាប់រងដែលរៀបចំតាមតម្រូវការ កាត់ពេលចេញបណ្ណធានារ៉ាប់រងចុះ 60% ហើយកម្រិតពេញចិត្តរបស់អតិថិជនកើនឡើង 35% ក្នុងរយៈពេល 6 ខែដំបូង។',
      image: '/images/portfolios/portfolio-banner.jpg',
    },
    {
      title: 'Sunrise Hotels',
      category: 'សណ្ឋាគារ',
      description:
        'ប្រព័ន្ធគ្រប់គ្រងធនធានមនុស្សរបស់យើងជួយគ្រប់គ្រងបុគ្គលិកនៅសណ្ឋាគារទាំង 5 កន្លែង។ ការរៀបចំវេនកាន់តែងាយស្រួល ហើយចំណាយរដ្ឋបាលថយចុះ 30%។',
      image: '/images/portfolios/portfolio-banner.jpg',
    },
    {
      title: 'Cambodia Manufacturing Co.',
      category: 'ផលិតកម្ម',
      description:
        'កញ្ចប់កម្មវិធីអាជីវកម្មពេញលេញរបស់យើងភ្ជាប់ផែនការផលិតកម្ម ការគ្រប់គ្រងស្តុក និងប្រតិបត្តិការហិរញ្ញវត្ថុចូលគ្នា។ លទ្ធផលគឺប្រសិទ្ធភាពប្រតិបត្តិការកើនឡើង 25%។',
      image: '/images/portfolios/portfolio-banner.jpg',
    },
    {
      title: 'Green Agriculture',
      category: 'កសិកម្ម',
      description:
        'ប្រព័ន្ធគ្រប់គ្រងស្តុក និងប្រតិបត្តិការតាមតម្រូវការ ជួយអ្នកផ្គត់ផ្គង់កសិកម្មរូបនេះតាមដានផលិតផលពីចម្ការរហូតដល់ដៃអតិថិជន។',
      image: '/images/portfolios/portfolio-banner.jpg',
    },
  ],
  cta: {
    title: 'ត្រៀមខ្លួនជារឿងជោគជ័យបន្ទាប់របស់យើងហើយឬនៅ?',
    body: 'ទាក់ទងមកយើងថ្ងៃនេះ ដើម្បីពិភាក្សាថាដំណោះស្រាយ AKAS អាចផ្លាស់ប្តូរប្រតិបត្តិការអាជីវកម្មរបស់អ្នកយ៉ាងដូចម្តេច។',
    button: 'ទាក់ទងមកយើង',
  },
};
